"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
if (document.getElementById('js-home')) {
  window.vueHome = new Vue({
    delimiters: ['[[', ']]'],
    el: '#js-home',
    data: {
      filters: {
        year: null,
        territory: '',
        levels: [],
        modes: [],
        populations: [],
        services: []
      },
      rawData: [],
      filteredData: [],
      domainData: [],
      domains: [],
      levels: [],
      modes: [],
      years: [],
      populations: {
        'Moins de 50 000 hab.': {
          min: 0,
          max: 50000
        },
        'De 50 000 à 100 000 hab.': {
          min: 50000,
          max: 100000
        },
        'Plus de 100 000 hab': {
          min: 100000,
          max: 99999999999
        }
      },
      region: '',
      regions: [],
      bounds: null,
      territories: [],
      territoriesObj: {},
      territoriesObjByDomain: {},
      statics: [{
        key: 'territories',
        useStorage: false,
        params: {
          limit: 400
        },
        callback: function callback(context) {
          return context.getData();
        }
      }, {
        key: 'domains',
        useStorage: false
      }, {
        key: 'levels',
        useStorage: false
      }, {
        key: 'modes',
        useStorage: false
      }, {
        key: 'regions',
        useStorage: false
      }, {
        key: 'years',
        useStorage: false,
        params: {
          ordering: '-year'
        },
        callback: function callback(context) {
          return context.initYear();
        }
      }],
      map: null,
      markers: [],
      cluster: null,
      currentYear: null,
      currentDomain: null,
      currentTerritory: null,
      showDescription: false,
      autocomplete: [],
      focus: false,
      loading: false,
      filtersOpen: false,
      isMobile: false,
      selectedServicesLevel: null,
      selectedServicesMode: null,
      selectedServiceSlug: null,
      servicesDetails: {},
      servicesDetailsLoading: false,
      servicesDetailsRequestId: 0
    },
    mounted: function mounted() {
      var _this = this;
      this.statics.forEach(function (s, index) {
        return _this.getStaticData(s, index);
      });
      this.updateIsMobile();
      window.addEventListener('resize', this.updateIsMobile, {
        passive: true
      });
      window.addEventListener('orientationchange', this.updateIsMobile, {
        passive: true
      });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) _this.invalidateMap();
      });
    },
    computed: {
      getAutocomplete: function getAutocomplete() {
        var _this2 = this;
        return this.territories.filter(function (t) {
          return t.name.toLowerCase().includes(_this2.filters.territory.toLowerCase());
        });
      },
      visibleDomains: function visibleDomains() {
        var hiddenDomainsByYear = {
          2026: ["petite-enfance", "gestion-des-equipements-culturels", "gestion-des-equipements-sportifs", "funeraires", "palais-des-congres"]
        };
        var hidden = hiddenDomainsByYear[this.filters.year] || [];
        return this.domains.filter(function (domain) {
          return !hidden.includes(domain.slug);
        });
      },
      filteredServicesForDescription: function filteredServicesForDescription() {
        var _this3 = this;
        if (!this.currentTerritory || !this.currentYear) return [];
        var services = this.getValue('services') || [];
        if (this.selectedServicesLevel) {
          services = services.filter(function (slug) {
            var detail = _this3.servicesDetails[slug];
            return detail && detail.level && detail.level.short_code === _this3.selectedServicesLevel;
          });
        }
        if (this.selectedServicesMode) {
          services = services.filter(function (slug) {
            var detail = _this3.servicesDetails[slug];
            return detail && detail.mode && detail.mode.short_code === _this3.selectedServicesMode;
          });
        }
        return services;
      }
    },
    methods: {
      /***********************************
      GET DATA
      ***********************************/
      getStaticData: function getStaticData(path, index) {
        var _this4 = this;
        if (localStorage.getItem('igd-' + path.key) && path.useStorage) {
          this[path.key] = JSON.parse(localStorage.getItem('igd-' + path.key));
          if (path.hasOwnProperty('callback')) {
            path.callback(this);
          }
        } else {
          // http://atlas-igd.vingtcinq.io/api/v1/territories
          axios.get("/api/v1/".concat(path.key), {
            params: path.hasOwnProperty('params') ? Object.assign({
              limit: 300
            }, path.params) : {
              limit: 300
            }
          }).then(function (response) {
            _this4[path.key] = response.data.results;
            localStorage.setItem('igd-' + path.key, JSON.stringify(_this4[path.key]));
            if (_this4.rawData.length) {
              _this4.filter();
            }
            if (path.hasOwnProperty('callback')) {
              setTimeout(function () {
                path.callback(_this4);
              }, 0);
            }
          });
        }
      },
      getData: function getData() {
        var _this5 = this;
        this.loading = true;
        axios.get('/api/v1/rawdata/stats').then(function (response) {
          setTimeout(function () {
            _this5.loading = false;
          }, 500);
          _this5.rawData = response.data;
          _this5.setTerritories();
          _this5.filter();
        });
      },
      getDataBy: function getDataBy() {
        var _this6 = this;
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
        this.loading = true;
        var path = this.currentDomain ? 'domains' : 'stats';
        var params = this.currentDomain ? {
          domain__name: this.currentDomain.slug
        } : {};
        params = this.region != '' ? Object.assign(params, {
          region: this.region
        }) : params;
        axios.get('/api/v1/rawdata/' + path, {
          params: params
        }).then(function (response) {
          if (_this6.currentDomain) {
            _this6.domainData = response.data;
            _this6.setTerritoriesByDomain();
            _this6.filter(false);
          } else {
            _this6.rawData = response.data;
            _this6.setTerritories();
            _this6.filter();
          }
          setTimeout(function () {
            _this6.loading = false;
          }, 500);
          callback(response);
        });
      },
      initYear: function initYear() {
        this.filters.year = this.years[0].year;
      },
      /***********************************
      FILTERING
      ***********************************/
      filter: function filter() {
        var center = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        this.closeDescription();
        this.filteredData = this.setFilteredData(center);
        this.filterMap();
      },
      setFilteredData: function setFilteredData(center) {
        var _this7 = this;
        var data = !this.currentDomain ? _toConsumableArray(this.rawData) : _toConsumableArray(this.domainData);
        Object.keys(this.filters).map(function (key, index) {
          var filter = _this7.filters[key];
          if (key == 'year') {
            data = data.filter(function (el) {
              return el[key] == parseInt(filter);
            });
          } else if (typeof filter == 'string' && filter != '') {
            data = data.filter(function (el) {
              return el[key].includes(filter);
            });
          } else if (_typeof(filter) == 'object' && filter.length) {
            if (key == 'populations') {
              data = data.filter(function (el) {
                var population = el[key.replace('s', '')];
                return filter.reduce(function (prev, current) {
                  var filterObj = _this7.populations[current];
                  return prev || population > filterObj.min && population < filterObj.max;
                }, false);
              });
            } else if (key == 'services') {
              data = data.filter(function (el) {
                var services = el.services || [];
                return filter.reduce(function (prev, curr) {
                  return prev || services.includes(curr);
                }, false);
              });
            } else {
              data = !_this7.currentDomain ? data.filter(function (el) {
                return filter.reduce(function (prev, curr) {
                  return prev || el[key].reduce(function (_prev, _curr) {
                    return _prev || _curr[key.replace('s', '')] == curr;
                  }, false);
                }, false);
              }) : data.filter(function (el) {
                return _this7.filters[key].includes(el.services[0][key.replace('s', '')].short_code);
              });
            }
          }
        });
        if (center && this.territoriesObj[this.filters.territory].hasOwnProperty('location')) {
          this.centerMap(this.territoriesObj[this.filters.territory].location);
        }
        return data;
      },
      filterByDomain: function filterByDomain(domain) {
        this.closeDescription();
        if (this.currentDomain == domain) {
          this.currentDomain = '';
        } else {
          this.currentDomain = domain;
        }
        this.getDataBy();
      },
      filterByRegion: function filterByRegion() {
        var _this8 = this;
        this.closeDescription();
        this.clearRegion();
        setTimeout(function () {
          if (_this8.region) {
            _this8.map.data.loadGeoJson(window.staticUrl + '/regions/' + _this8.region + '.geojson');
          } else {
            _this8.setDefaultMap();
          }
        }, 100);
        this.getDataBy();
      },
      clearRegion: function clearRegion() {
        var _this9 = this;
        this.bounds = null;
        this.map.data.forEach(function (data) {
          return _this9.map.data.remove(data);
        });
      },
      mapCheckboxes: function mapCheckboxes(key, event, name) {
        var filter = this.filters[key];
        var index = filter.indexOf(name);
        var isChecked = event.srcElement.checked;
        if (isChecked && index < 0) {
          filter.push(name);
        } else if (!isChecked && index >= 0) {
          filter.splice(index, 1);
        }
        this.filter();
      },
      toggleFilterArray: function toggleFilterArray(key, value) {
        var filter = this.filters[key];
        var index = filter.indexOf(value);
        if (index < 0) {
          filter.push(value);
        } else {
          filter.splice(index, 1);
        }
        this.filter();
      },
      isFilterActive: function isFilterActive(key, value) {
        return this.filters[key] && this.filters[key].includes(value);
      },
      getDomainLabelBySlug: function getDomainLabelBySlug(slug) {
        var d = this.domains.find(function (x) {
          return x.slug === slug;
        });
        return d ? d.name : slug;
      },
      getDomainBySlug: function getDomainBySlug(slug) {
        return this.domains.find(function (d) {
          return d.slug === slug;
        }) || null;
      },
      getIconBySlug: function getIconBySlug(slug) {
        return 'icon-' + slug;
      },
      autocompleteFocus: function autocompleteFocus() {
        this.focus = true;
      },
      autocompleteFocusOut: function autocompleteFocusOut() {
        this.focus = false;
      },
      autocompleteSelect: function autocompleteSelect(val) {
        this.filters.territory = val;
        this.autocompleteFocusOut();
        this.filter(true);
      },
      autocompleteClear: function autocompleteClear() {
        this.filters.territory = '';
        this.$refs.autocomplete.focus();
        this.filter();
        this.setDefaultMap();
      },
      autocompletePrevent: function autocompletePrevent(event) {
        if (event.keyCode == '40') {
          event.preventDefault();
          if (event.srcElement.nextElementSibling) {
            event.srcElement.nextElementSibling.focus();
          }
        }
      },
      autocompleteFocusItem: function autocompleteFocusItem(event) {
        if (event.srcElement.firstChild) {
          event.srcElement.firstChild.focus();
        }
      },
      autocompleteNavigate: function autocompleteNavigate(event) {
        if (event.keyCode == 38) {
          event.preventDefault();
          var previous = event.srcElement.previousSibling;
          if (previous) {
            previous.focus();
          }
        }
        if (event.keyCode == 40) {
          event.preventDefault();
          var next = event.srcElement.nextSibling;
          if (next) {
            next.focus();
          }
        }
        if (event.keyCode == 13) {
          event.srcElement.click();
        }
      },
      preventClick: function preventClick(event) {
        event.stopPropagation();
      },
      reset: function reset() {
        var _this0 = this;
        this.filters = {
          year: this.years[0].year,
          territory: '',
          modes: [],
          levels: [],
          populations: [],
          services: []
        };
        this.currentDomain = null;
        this.filter();
        if (this.region) {
          this.region = '';
          this.clearRegion();
          this.getData();
        }
        setTimeout(function () {
          _this0.setDefaultMap();
        }, 500);
      },
      /***********************************
      TERRITORIES
      ***********************************/
      setTerritories: function setTerritories() {
        var _this1 = this;
        var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.territoriesObj;
        var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rawData;
        var obj = {};
        this.territories.forEach(function (territory) {
          var years = _this1.rawData.filter(function (el) {
            return el.territory === territory.name;
          });
          territory['years'] = years;
          if (!obj.hasOwnProperty(territory.name)) {
            obj[territory.name] = territory;
          }
          obj[territory.name]['years'] = {};
          years.forEach(function (year) {
            obj[territory.name]['years'][year.year] = year;
          });
          if (years.length) {
            obj[territory.name]['location'] = years[0].location;
          }
        });
        this.territoriesObj = obj;
      },
      setTerritoriesByDomain: function setTerritoriesByDomain() {
        var _this10 = this;
        var obj = {};
        _toConsumableArray(this.territories).forEach(function (territory) {
          var years = _this10.domainData.filter(function (el) {
            return el.territory === territory.name;
          });
          if (!obj.hasOwnProperty(territory.name)) {
            obj[territory.name] = _objectSpread({}, territory);
          }
          obj[territory.name]['years'] = {};
          _toConsumableArray(years).forEach(function (year) {
            obj[territory.name]['years'][year.year] = Object.assign({}, _objectSpread({}, year));
          });
          if (years.length) {
            obj[territory.name]['location'] = years[0].location;
          }
        });
        this.territoriesObjByDomain = obj;
      },
      getTerritory: function getTerritory(territory) {
        var current = !this.currentDomain ? _objectSpread({}, this.territoriesObj[territory]) : _objectSpread({}, this.territoriesObjByDomain[territory]);
        if (current) {
          this.currentTerritory = current;
          this.openDescription();
        }
      },
      /***********************************
      DESCRIPTION PANEL
      ***********************************/
      openDescription: function openDescription() {
        this.showDescription = true;
        this.currentYear = this.filters.year;
        this.selectedServiceSlug = null;
        this.servicesDetails = {};
        this.servicesDetailsLoading = false;
        var levels = this.getValue('levels');
        this.selectedServicesLevel = levels && levels.length ? levels[0].level : null;
        this.selectedServicesMode = null;
        this.loadServicesDetailsForDescription();
      },
      closeDescription: function closeDescription() {
        this.currentTerritory = null;
        this.showDescription = false;

        /***********************************
        DESCRIPTION UI (AJOUT)
        ***********************************/
        this.selectedServicesLevel = null;
        this.selectedServicesMode = null;
        this.selectedServiceSlug = null;
        this.servicesDetails = {};
        this.servicesDetailsLoading = false;
      },
      getIcon: function getIcon(domain) {
        return 'icon-' + domain.slug;
      },
      getChip: function getChip(mode) {
        return 'chip-' + mode;
      },
      getValue: function getValue(key) {
        return this.currentTerritory.years[this.currentYear][key];
      },
      getValueByDomain: function getValueByDomain(key) {
        return this.currentTerritory.years[this.currentYear].services[0][key];
      },
      getIndex: function getIndex() {
        var _this11 = this;
        var index;
        Object.keys(this.currentTerritory.years).filter(function (key, i) {
          if (key == _this11.currentYear) {
            index = i;
          }
        });
        return index;
      },
      getKeyByIndex: function getKeyByIndex() {
        var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var k;
        var index = this.getIndex();
        Object.keys(this.currentTerritory.years).filter(function (key, i) {
          if (i == index + delta) {
            k = key;
          }
        });
        return k;
      },
      hasPrev: function hasPrev() {
        return this.getIndex() > 0;
      },
      hasNext: function hasNext() {
        return this.getIndex() < Object.keys(this.currentTerritory.years).length - 1;
      },
      prev: function prev() {
        this.currentYear = this.getKeyByIndex(-1);
        this.onDescriptionYearChange();
      },
      next: function next() {
        this.currentYear = this.getKeyByIndex(1);
        this.onDescriptionYearChange();
      },
      hasIntercom: function hasIntercom() {
        return this.currentTerritory.years[this.currentYear].hasOwnProperty('intercommunality');
      },
      getIntercom: function getIntercom() {
        return this.currentTerritory.years[this.currentYear].intercommunality;
      },
      getChart: function getChart() {
        var serializer = new XMLSerializer();
        return serializer.serializeToString(this.setChart(this.getValue('modes'), 23));
      },
      onDescriptionYearChange: function onDescriptionYearChange() {
        var _this12 = this;
        if (!this.currentTerritory) return;
        this.selectedServiceSlug = null;
        this.servicesDetails = {};
        var levels = this.getValue('levels');
        if (levels && levels.length) {
          if (!this.selectedServicesLevel || !levels.some(function (l) {
            return l.level === _this12.selectedServicesLevel;
          })) {
            this.selectedServicesLevel = levels[0].level;
          }
        } else {
          this.selectedServicesLevel = null;
        }
        var modes = this.getValue('modes');
        if (this.selectedServicesMode && (!modes || !modes.length || !modes.some(function (m) {
          return m.mode === _this12.selectedServicesMode;
        }))) {
          this.selectedServicesMode = null;
        }
        this.loadServicesDetailsForDescription();
      },
      selectServicesLevel: function selectServicesLevel(levelShortCode) {
        this.selectedServicesLevel = this.selectedServicesLevel === levelShortCode ? null : levelShortCode;
        this.selectedServicesMode = null;
        this.selectedServiceSlug = null;
      },
      selectServicesMode: function selectServicesMode(modeShortCode) {
        this.selectedServicesMode = this.selectedServicesMode === modeShortCode ? null : modeShortCode;
        this.selectedServicesLevel = null;
        this.selectedServiceSlug = null;
      },
      isServicesLevelActive: function isServicesLevelActive(levelShortCode) {
        return this.selectedServicesLevel === levelShortCode;
      },
      isServicesModeActive: function isServicesModeActive(modeShortCode) {
        return this.selectedServicesMode === modeShortCode;
      },
      selectServiceSlug: function selectServiceSlug(serviceSlug) {
        this.selectedServiceSlug = serviceSlug;
      },
      isServiceActive: function isServiceActive(serviceSlug) {
        return this.selectedServiceSlug === serviceSlug;
      },
      getServiceDetail: function getServiceDetail(serviceSlug) {
        return this.servicesDetails[serviceSlug] || null;
      },
      getServiceModeShortCode: function getServiceModeShortCode(serviceSlug) {
        var d = this.getServiceDetail(serviceSlug);
        return d && d.mode ? d.mode.short_code : '';
      },
      getServiceModeLabel: function getServiceModeLabel(serviceSlug) {
        var d = this.getServiceDetail(serviceSlug);
        return d && d.mode ? d.mode.label : '—';
      },
      getServiceLevelLabel: function getServiceLevelLabel(serviceSlug) {
        var d = this.getServiceDetail(serviceSlug);
        return d && d.level ? d.level.label : '—';
      },
      loadServicesDetailsForDescription: function loadServicesDetailsForDescription() {
        var _this13 = this;
        if (!this.currentTerritory || !this.currentYear) return;
        var territoryName = this.currentTerritory.name;
        var year = parseInt(this.currentYear);
        var services = this.getValue('services') || [];
        if (!services.length) return;
        var requestId = ++this.servicesDetailsRequestId;
        this.servicesDetailsLoading = true;
        this.servicesDetails = {};
        axios.get('/api/v1/rawdata/services-details', {
          params: {
            territory: territoryName,
            year: year,
            services: services.join(',')
          }
        }).then(function (response) {
          if (requestId !== _this13.servicesDetailsRequestId) return;
          services.forEach(function (slug) {
            _this13.$set(_this13.servicesDetails, slug, response.data[slug] || null);
          });
        }).catch(function () {
          if (requestId !== _this13.servicesDetailsRequestId) return;
          services.forEach(function (slug) {
            return _this13.$set(_this13.servicesDetails, slug, null);
          });
        }).finally(function () {
          if (requestId !== _this13.servicesDetailsRequestId) return;
          _this13.servicesDetailsLoading = false;
        });
      },
      /***********************************
      MAP GESTION
      ***********************************/
      initMap: function initMap() {
        var _this14 = this;
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: {
            lat: 46.227638,
            lng: 2.213749
          },
          zoom: 6,
          zoomControl: false,
          scaleControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          styles: mapStyles
        });
        this.setCustomMarkerPrototype();
        this.map.data.setStyle({
          fillColor: '#2A89C5',
          strokeColor: '#074885',
          strokeWeight: 1
        });
        this.map.data.addListener('addfeature', function (e) {
          _this14.bounds = new google.maps.LatLngBounds();
          _this14.processPoints(e.feature.getGeometry(), _this14.bounds.extend, _this14.bounds);
          _this14.map.fitBounds(_this14.bounds);
        });
      },
      processPoints: function processPoints(geometry, callback, thisArg) {
        var _this15 = this;
        if (geometry instanceof google.maps.LatLng) {
          callback.call(thisArg, geometry);
        } else if (geometry instanceof google.maps.Data.Point) {
          callback.call(thisArg, geometry.get());
        } else {
          geometry.getArray().forEach(function (g) {
            _this15.processPoints(g, callback, thisArg);
          });
        }
      },
      filterMap: function filterMap() {
        var _this16 = this;
        if (this.map) {
          this.markers = this.filteredData.map(function (marker, index) {
            var m = new _this16.customMarker(marker, index);
            return m;
          });
          if (this.cluster) {
            this.cluster.clearMarkers();
            this.cluster.addMarkers(this.markers);
          } else {
            this.cluster = new MarkerClusterer(this.map, this.markers, {
              minimumClusterSize: 10
            });
          }
        }
      },
      zoom: function zoom() {
        var back = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var zoom = this.map.getZoom() + (back ? -1 : 1);
        this.map.setZoom(zoom > 2 ? zoom : 2);
      },
      centerMap: function centerMap(data) {
        this.map.setCenter({
          lat: data.lat,
          lng: data.long
        });
        this.map.setZoom(10);
      },
      setDefaultMap: function setDefaultMap() {
        this.map.setCenter({
          lat: 46.227638,
          lng: 2.213749
        });
        this.map.setZoom(6);
      },
      setChart: function setChart(modes) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 19;
        if (modes) {
          var total = modes.reduce(function (prev, curr) {
            return prev + curr.count;
          }, 0);
          var list = ['GD', 'GC', 'RD', 'NC'];
          var dataSectors = list.map(function (key) {
            if (modes.some(function (el) {
              return el.mode == key;
            })) {
              var val = modes.filter(function (el) {
                return el.mode == key;
              })[0].count;
              return {
                percentage: modes.filter(function (el) {
                  return el.mode == key;
                })[0].count / total,
                val: val,
                total: total
              };
            }
            return {
              percentage: 0
            };
          });
          var data = {
            size: size,
            sectors: dataSectors
          };
          var sectors = calculateSectors(data);
          var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          svg.setAttributeNS(null, 'style', "width: " + data.size + "px; height: " + data.size + "px");
          sectors.map(function (sector) {
            var newSector = document.createElementNS("http://www.w3.org/2000/svg", "path");
            newSector.setAttributeNS(null, 'fill', sector.color);
            newSector.setAttributeNS(null, 'd', 'M' + sector.L + ',' + sector.L + ' L' + sector.L + ',0 A' + sector.L + ',' + sector.L + ' 0 ' + sector.arcSweep + ',1 ' + sector.X + ', ' + sector.Y + ' z');
            newSector.setAttributeNS(null, 'transform', 'rotate(' + sector.R + ', ' + sector.L + ', ' + sector.L + ')');
            svg.appendChild(newSector);
          });
          return svg;
        }
      },
      setCustomMarkerPrototype: function setCustomMarkerPrototype() {
        var that = this;
        this.customMarker = function CustomMarker(marker, index) {
          this.coords = new google.maps.LatLng(marker.location.lat, marker.location.long);
          this.territory = marker.territory;
          this.index = index;
          this.marker = marker;
        };
        this.customMarker.prototype = new google.maps.OverlayView();
        this.customMarker.prototype.draw = function () {
          var _this17 = this;
          var div = this.div;
          if (!div) {
            var panes = this.getPanes();
            div = this.div = document.createElement('div');
            div.className = 'marker';
            div.innerHTML = div.innerHTML + '<span>' + this.territory + '</span><div></div>';
            if (this.marker.hasOwnProperty('modes')) {
              if (this.marker.modes.length > 1) {
                div.querySelector('div').appendChild(that.setChart(this.marker.modes));
              } else {
                div.querySelector('div').classList.add('is-' + this.marker.modes[0].mode);
              }
            } else {
              div.querySelector('div').classList.add('is-' + this.marker.services[0].mode.short_code);
            }
            panes.overlayImage.appendChild(div);
            google.maps.event.addDomListener(this.div, "click", function () {
              that.getTerritory(that.filteredData[_this17.index].territory);
            });
          }
          var point = this.getProjection().fromLatLngToDivPixel(this.coords);
          if (point) {
            div.style.left = point.x - 15 + 'px';
            div.style.top = point.y - 15 + 'px';
          }
          this.div = div;
        };
        this.customMarker.prototype.remove = function () {
          if (this.div) {
            google.maps.event.clearInstanceListeners(this.div);
            this.div.parentNode.removeChild(this.div);
            this.div = null;
          }
        };
        this.customMarker.prototype.getPosition = function () {
          return this.coords;
        };
        this.customMarker.prototype.getDraggable = function () {};
      },
      openFilters: function openFilters() {
        var _this18 = this;
        this.filtersOpen = true;
        this.lockScroll(true);
        this.$nextTick(function () {
          return _this18.invalidateMap();
        });
      },
      closeFilters: function closeFilters() {
        var _this19 = this;
        this.filtersOpen = false;
        this.lockScroll(false);
        this.$nextTick(function () {
          return _this19.invalidateMap();
        });
      },
      toggleFilters: function toggleFilters() {
        this.filtersOpen ? this.closeFilters() : this.openFilters();
      },
      updateIsMobile: function updateIsMobile() {
        this.isMobile = window.matchMedia('(max-width: 1023px)').matches; // ajuste si besoin
        if (!this.isMobile && this.filtersOpen) this.closeFilters();
      },
      maybeCloseFilters: function maybeCloseFilters() {
        if (this.isMobile) this.closeFilters();
      },
      invalidateMap: function invalidateMap() {
        if (!this.map) return;
        var center = this.map.getCenter && this.map.getCenter();
        google.maps.event.trigger(this.map, 'resize');
        if (center) this.map.setCenter(center);
      },
      lockScroll: function lockScroll(lock) {
        document.documentElement.classList.toggle('has-map-drawer-open', lock);
      }
    }
  });
}
function initMap() {
  if (window.vueHome) {
    window.vueHome.initMap();
  }
}
function calculateSectors(data) {
  var sectors = [];
  var colors = ["#074885", "#FFE600", "#EF7D00", "#EEF0FA"];
  var l = data.size / 2;
  var a = 0;
  var aRad = 0;
  var z = 0;
  var x = 0;
  var y = 0;
  var X = 0;
  var Y = 0;
  var R = 0;
  data.sectors.map(function (item, key) {
    var a = 360 * item.percentage;
    var aCalc = a > 180 ? 360 - a : a;
    var aRad = aCalc * Math.PI / 180;
    var z = Math.sqrt(2 * l * l - 2 * l * l * Math.cos(aRad));
    var arcSweep;
    if (aCalc <= 90) {
      x = l * Math.sin(aRad);
    } else {
      x = l * Math.sin((180 - aCalc) * Math.PI / 180);
    }
    y = Math.sqrt(z * z - x * x);
    Y = y;
    if (a <= 180) {
      X = l + x;
      arcSweep = 0;
    } else {
      X = l - x;
      arcSweep = 1;
    }
    sectors.push({
      percentage: item.percentage,
      color: colors[key],
      arcSweep: arcSweep,
      L: l,
      X: X,
      Y: Y,
      R: R
    });
    R = R + a;
  });
  return sectors;
}
var mapStyles = [{
  "featureType": "administrative",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#2989c5"
  }]
}, {
  "featureType": "administrative.province",
  "elementType": "geometry.stroke",
  "stylers": [{
    "visibility": "on"
  }]
}, {
  "featureType": "landscape",
  "elementType": "all",
  "stylers": [{
    "color": "#f2f2f2"
  }]
}, {
  "featureType": "poi",
  "elementType": "all",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "road",
  "elementType": "all",
  "stylers": [{
    "saturation": -100
  }, {
    "lightness": 45
  }, {
    "visibility": "off"
  }]
}, {
  "featureType": "road.highway",
  "elementType": "all",
  "stylers": [{
    "visibility": "simplified"
  }, {
    "lightness": "0"
  }]
}, {
  "featureType": "road.arterial",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "transit",
  "elementType": "all",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "water",
  "elementType": "all",
  "stylers": [{
    "color": "#aadbff"
  }, {
    "visibility": "on"
  }]
}];